import uniqid from 'uniqid';

function DriverPasswordGenerator() {
  const id = uniqid();

  return id.slice(0, 8);
}

export default DriverPasswordGenerator;